<template>
  <div class="push-message-composer-button">
    <a href="" @click.prevent="showComposer = true">Send Message</a>
    <div class="message-composer" v-if="showComposer">
      <ace-editor v-model="content" @init="editorInit" lang="javascript" theme="ambiance" width="80%" height="100%" />
      <div class="button-bar">
        <a class="composer-exit" href="" @click.prevent="showComposer = false">Exit</a>
        <a class="button" href="" @click.prevent="sendMessage()">Send Message</a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        showComposer: false,
        content: ''
      }
    },
    props: ['device'],
    methods: {
      editorInit: function () {
        require('brace/ext/language_tools')
        require('brace/mode/javascript')
        require('brace/theme/ambiance')
      },
      sendMessage: function () {
        console.log(this.device)
        this.$store.dispatch('sendPushMessage', {
          device: this.device,
          data: JSON.parse(this.content)
        })
      }
    }
  }
</script>
<style lang="less">
  .message-composer {
    position: fixed;
    top: 1em;
    right: 1em;
    bottom: 1em;
    left: 1em;
    border: 1px solid cyan;
    background: black;

    .button-bar {
      position: absolute;
      top: 0;
      left: 80%;
      right: 0;
      bottom: 0;
      border-left: 1px solid cyan;
      padding: 1em;

      .composer-exit {
        display: block;
        width: 100%;
        text-align: right;
      }

      .button {
        display: block;
        width: 100%;
        border: 1px solid green;
        background: black;
        padding: 1em 0;
        text-align: center;
      }

      .button:hover {
        background: #885b00;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DeviceMessageComposer.vue